var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4348 6.59965L11.4823 1.58491H1.56522V19.4151H16.4348V6.59965ZM18 21H0V0H12.1304L18 5.9434V21Z",
    fill: "#196BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13086 9.90576H14.87V11.4907H3.13086V9.90576Z",
    fill: "#196BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1309 1.58496L12.1309 7.52836L10.5656 7.52836L10.5656 1.58496L12.1309 1.58496Z",
    fill: "#196BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4346 7.52832L10.565 7.52832L10.565 5.94341L16.4346 5.94342L16.4346 7.52832Z",
    fill: "#196BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13086 13.0754H14.87V14.6603H3.13086V13.0754Z",
    fill: "#196BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13086 16.2456H9.00042V17.8305H3.13086V16.2456Z",
    fill: "#196BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileList);
export default __webpack_public_path__ + "static/media/fileList.c74ecbe1b0eeed981c1cdfa2fea37817.svg";
export { ForwardRef as ReactComponent };